import React, { useReducer, createContext, } from 'react';

export const NocContext = createContext('');

const initialState = {
    nocList: [],
    totalRecords: 0,
    pageSize: 0,
    currentNocItem: {},
    loading: false, 
    error: null,
};

const reducer = (state, action) => {
    switch(action.type) {
        case 'SET_NOC_LIST':
            return {
                ...state,
                nocList: action.payload,
            };
        case 'SET_TOTAL_RECORDS': 
            return {
                ...state, 
                totalRecords: action.payload,
            }
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.payload,
            }
        case 'SET_CURRENT_NOC_ITEM':
            return{
                ...state,
                currentNocItem: action.payload,
            }
        case 'UPDATE_CUSTOMER_INFORMATION': 
            let customerId = action.payload.id;
            return {
                ...state, 
                currentNocItem: ({...state.currentNocItem, ...action.payload}),
                nocList: state.nocList.map(noc => noc.id === customerId ? action.payload : noc),
            }
        case "ADD_CUSTOMER":
            return {
                ...state,
                nocList: ([...state.nocList, action.payload])
            };
        case 'DELETE_CUSTOMER':
            return {
                ...state,
                nocList: [...state.nocList.filter(item => item.id !== action.payload)],
                currentNocItem: {},
                totalRecords: state.totalRecords - 1,
            };
        case 'START': 
            return {
                loading: true
            };
        
        default: 
            throw new Error();
    }
};

export const NocContextProvider = props => {
    
    const [state, dispatch] = useReducer(reducer, initialState);

    return(
        <NocContext.Provider value={[state, dispatch]}>
            {props.children}
        </NocContext.Provider>
    )
}
